module.exports = __webpack_public_path__ + "img/APA stepping 1980 2.55c7ab1f.png";